// hooks/useApi.js
import { useCallback, useState } from "react";
import { graphqlRequest } from "../common/apiClient";

export function useApi() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const callApi = useCallback(async (query, variables = {}) => {
    try {
      setLoading(true);
      setError(null);
      const data = await graphqlRequest(query, variables);
      return data;
    } catch (err) {
      setError(err.message || "API error");
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { callApi, loading, error };
}
